import { useState, useMemo } from "react";
import {
  Box,
  Fab,
  Paper,
  Typography,
  IconButton,
  TextField,
  Stack,
} from "@mui/material";

import Iconify from "src/components/iconify";
import ChatView from 'src/sections/AI/view/chat-view'
import Tooltip from "@mui/material/Tooltip";
import { useAuthContext } from "src/auth/hooks";

export default function FloatingButton() {
  const { user } = useAuthContext();
  const ruta = useMemo(() => (user?.rutas.find((r) => r.element === 'Chat')), [user])
  const [open, setOpen] = useState(false);

  const handleCloseChat = () => {
    setOpen(false)
  }

  return (
    <>
      <ChatView openChat={open} handleClose={handleCloseChat} />
      {/* BOTON FLOTANTE */}
      {user?.beccaChat === 'S' && ruta && (
        <Tooltip title="Habla con Becca Brain">
          <Fab
            color="primary"
            onClick={() => setOpen(!open)}
            sx={{
              position: "fixed",
              bottom: 200,
              right: 24,
              zIndex: 9999,
            }}
          >
            <Iconify icon="mdi:brain" />
          </Fab>
        </Tooltip>
      )}
    </>
  );
}